import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import styles from './IconButton.scss';
import SimpleButton from './SimpleButton';


export default function IconButton(props) {
    const {className, active, Icon, noWrapper, ...restProps} = props;

    return (
        <SimpleButton
            className={classnames(
                styles.button,
                {
                    [styles.active]: active,
                    [styles.noWrapper]: noWrapper,
                    },
                className,
            )}
            type="button"
            {...restProps}
        >
            <Icon className={styles.icon} />
        </SimpleButton>
    );
}

IconButton.propTypes = {
    className: PropTypes.string,
    active: PropTypes.bool,
    Icon: PropTypes.any,
};

IconButton.defaultProps = {
    className: null,
    active: false,
    Icon: null,
};



// WEBPACK FOOTER //
// ./src/components/controls/buttons/IconButton.jsx